import React from 'react';
import {connect} from "react-redux";
import ModalDialog from "../../../ui/ModalDialog/ModalDialog";
import {showOverQuota, showHelp} from "../../../store/modalsSlice";

const Help = (props) => {
	const handleClose = () => {
		props.showHelp(false);
	};

	return (
		<ModalDialog
			open={!!props.showingHelp} hideCancel={true}
			handleClose={handleClose} handleSubmit={handleClose} title='A2PoGo Custom Spawn Alerts'
			style={{height: '100%'}} submitString='Okay'
		>
			<p>This page allows you to create customized Discord notifications for Pokemon spawns.
				On the sidebar, you'll find a list of <i>Zones</i>, which are circular areas on the map to
				search for spawns. You can use the pre-defined zones (such as Downtown A2 or Ypsilanti), or
				create your own to find spawns in your neighborhood.</p>

			<p>Inside these zones, you can create <i>Alerts</i>. Alerts narrow down what you're looking for.
				For instance, you can create a zone where you work, and add an alert for high-IV Chansey spawns
				between the hours of 9-5. You can also just use the "Quality" slider to find the good stuff (it
				corresponds to the map quality levels, and factors in Pokemon species, IV, level, etc).
			</p>
		</ModalDialog>
	);
};

const mapStateToProps = (state) => {
	return {
		showingHelp: state.modals.showingHelp
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		showHelp: (val) => dispatch(showHelp(val))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Help);